import { SelectMultipleMarkerIcon } from './SelectMultipleMarkerIcon';

/**
 * author: Austin Andrews
 * id 0A8AB6EF-B388-4086-BF8D-1F0015ADC972
 * name select-multiple-marker
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/select-multiple-marker.svg
 * tags
 * - Navigation 
 */
export const SelectMultipleLocationIcon = SelectMultipleMarkerIcon;
export default SelectMultipleLocationIcon